import axiosClient from "./axiosClient";

/**
 * Get employees for a company
 * @param {number} companyId - ID of the company
 * @param {Array} storeIds - List of store IDs
 * @returns {Promise} - Promise with employee data
 */
export const getEmployeesForCompany = (companyId, storeIds) => {
    let storeIdsFilter = storeIds && storeIds.length > 0 ? ("&storeIds=" + storeIds.join(",")) : "";
    return axiosClient.get(`/administrators/employees?companyId=${companyId}${storeIdsFilter}`);
};



/**
 * Activate an employee
 * @param {number} employeeId - ID of the employee
 * @returns {Promise} Promise that resolves with the activated employee data
 */
export const activateEmployee = (employeeId) => {
    return axiosClient.put(`/administrators/employees/${employeeId}/activate`);
};

/**
* Deactivate an employee
* @param {number} employeeId - ID of the employee
* @returns {Promise} Promise that resolves with the deactivated employee data
*/
export const deactivateEmployee = (employeeId) => {
    return axiosClient.put(`/administrators/employees/${employeeId}/deactivate`);
};

/**
* Delete an employee
* @param {number} employeeId - ID of the employee
* @returns {Promise} Promise that resolves with the deletion response
*/
export const deleteEmployee = (employeeId) => {
    return axiosClient.delete(`/administrators/${employeeId}`);
};

/**
 * Get an employee by ID
 * @param {number} employeeId - ID of the employee
 * @returns {Promise} - Promise with employee data
 */
export const getEmployeeById = (employeeId) => {
    return axiosClient.get(`/administrators/${employeeId}`);
};

/**
 * Create a new employee
 * @param {object} employeeData - Data for the new employee
 * @returns {Promise} - Promise with the created employee data
 */
export const createEmployee = (employeeData) => {
    const apiData = {
        name: employeeData.name,
        lastName: employeeData.lastName,
        email: employeeData.email,
        phoneNumber: employeeData.phoneNumber,
        username: employeeData.username,
        active: true,
        companyId: employeeData.companyId,
        companies: [{ id: employeeData.companyId }],
        stores: [{ id: employeeData.storeId }],
        storeId: employeeData.storeId,
        // fields to avoid nulls
        avatar: "mini-noavatar.jpg",
        detractorsAlert: false,
        weeklyReport: false,
        weeklyReviewReport: false,
        sendWTEmail: false,
        reviewChangesAlert: false,
        locale: "es_AR",
        promotersAlert: 0
    };
    
    return axiosClient.post(`/administrators/employees`, apiData);
};

/**
 * Update an existing employee using the PUT endpoint
 * @param {number} employeeId - ID of the employee to update
 * @param {object} employeeData - New data for the employee
 * @returns {Promise} - Promise with the updated employee data
 */
export const updateEmployee = (employeeId, employeeData) => {
    const apiData = {
        name: employeeData.name,
        lastName: employeeData.lastName,
        email: employeeData.email,
        phoneNumber: employeeData.phoneNumber,
        username: employeeData.username,
        active: employeeData.active,
        companyId: employeeData.companyId,
        companies: [{ id: employeeData.companyId }],
        stores: [{ id: employeeData.storeId }],
        storeId: employeeData.storeId,
        // fields to avoid nulls
        avatar: "mini-noavatar.jpg",
        detractorsAlert: false,
        weeklyReport: false,
        weeklyReviewReport: false,
        sendWTEmail: false,
        reviewChangesAlert: false,
        locale: "es_AR",
        promotersAlert: 0
    };
    
    return axiosClient.put(`/administrators/employees/${employeeId}`, apiData);
};